export default "__VITE_ASSET__MIKXPve9__"